import { Component } from '@angular/core';

@Component({
  selector: 'app-invitation-invalid',
  imports: [],
  templateUrl: './invitation-invalid.component.html',
  styleUrl: './invitation-invalid.component.css'
})
export class InvitationInvalidComponent {

}
